<div class="flex flex-col gap-2" [formGroup]="pharmacyForm()">
  <label for="commercial" class="text-[14px] font-[500] hover:cursor-pointer" i18n="@@commercialRegNumberLabel">
    Commercial Registration Number
    <span class="text-danger-text">*</span>
  </label>
  <input
    id="commercial"
    type="text"
    formControlName="commercialRegisterNumber"
    placeholder="Enter Commercial Registeration Number"
    i18n-placeholder="@@commercialRegNumberPlaceholder"
    class="border-border bg-surface-subtle placeholder-text-gray hover-border-input-border focus-border-gray-strong rounded-[6px] border-[1px] px-3 py-2 text-[14px] focus:bg-white focus:outline-none"
    [class.border-red-500]="
      pharmacyForm().get('commercialRegisterNumber')?.invalid && pharmacyForm().get('commercialRegisterNumber')?.touched
    " />
  @if (
    pharmacyForm().get("commercialRegisterNumber")?.invalid && pharmacyForm().get("commercialRegisterNumber")?.touched
  ) {
    <span class="text-danger-text text-[12px]">
      @if (pharmacyForm().get("commercialRegisterNumber")?.errors?.["required"]) {
        <span i18n="@@commercialRegNumberRequired">Commercial Registration Number is required</span>
      }
      @if (
        pharmacyForm().get("commercialRegisterNumber")?.errors?.["minlength"] &&
        !pharmacyForm().get("commercialRegisterNumber")?.errors?.["pattern"]
      ) {
        <span i18n="@@commercialRegNumberMinLength">Commercial Registration Number must be at least 5 characters</span>
      }
      @if (
        pharmacyForm().get("commercialRegisterNumber")?.errors?.["maxlength"] &&
        !pharmacyForm().get("commercialRegisterNumber")?.errors?.["pattern"]
      ) {
        <span i18n="@@commercialRegNumberMaxLength">Commercial Registration Number cannot exceed 20 characters</span>
      }
      @if (pharmacyForm().get("commercialRegisterNumber")?.errors?.["pattern"]) {
        <span i18n="@@commercialRegNumberPattern">
          Commercial Registration Number can only contain letters, numbers, hyphens, and slashes
        </span>
      }
    </span>
  }
</div>
